var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaQs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11641",
    transform: "translate(-12905.75 5494.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11637",
    transform: "translate(12913.72 -5488.905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7,27.4C16.7,27.4,16.7,27.4,16.7,27.4c-1,0-1.7-0.8-1.7-1.7c0.1-3.7,3.6-6,5.7-7.5c0.3-0.2,0.6-0.4,0.8-0.6 c0.2-3.7-0.3-6.3-1.6-7.8c-0.8-0.8-1.8-1.2-3.3-1.2c-1.4,0-2.4,0.4-3.2,1.3c-1.9,2.2-1.7,6.6-1.5,8.1c0.1,0.9-0.5,1.7-1.4,1.9 c-0.9,0.1-1.7-0.5-1.9-1.4c0-0.3-0.9-7,2.3-10.7c1.4-1.6,3.3-2.4,5.7-2.4c2.4,0,4.3,0.8,5.7,2.3c3,3.2,2.6,8.6,2.5,10.4l0,0.3 c0,1.2-0.9,1.8-2.3,2.7c-1.7,1.1-4.2,2.8-4.3,4.8C18.3,26.7,17.6,27.4,16.7,27.4z M21.6,18.4L21.6,18.4L21.6,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,33.4c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5C18.9,32.3,17.8,33.4,16.4,33.4z M16.4,30.1 c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8C17.2,30.5,16.8,30.1,16.4,30.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12929.8-5446.9c-12.9,0-23.4-10.5-23.4-23.4s10.5-23.4,23.4-23.4s23.4,10.5,23.4,23.4S12942.6-5446.9,12929.8-5446.9z  M12929.8-5490.3c-11.1,0-20.1,9-20.1,20.1c0,11.1,9,20.1,20.1,20.1s20.1-9,20.1-20.1 C12949.8-5481.3,12940.8-5490.3,12929.8-5490.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/FAQs.00ae7974fff5ba2188ccf83a827003a2.svg";
export { ForwardRef as ReactComponent };